import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4),
    gap: theme.spacing(4),
    background: theme.colorPalette.green_90,
    ...reskinStyles(theme, theme.cardStyles.highlight)
  },
  block: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    maxWidth: 880,
    width: '100%',
    gap: theme.spacing(2)
  },
  iconRow: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  },
  row: {
    display: 'flex',
    gap: theme.spacing(4),
    // Reskin: Chrome sized the shrink-to-fit Cabin title a pixel or two short, so it wrapped onto the subtitle.
    ...reskinStyles(theme, { flex: '1 1 auto', minWidth: 0 })
  },
  titleColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    ...reskinStyles(theme, { flex: '1 1 auto', minWidth: 0 })
  },
  code: {
    fontSize: 10,
    lineHeight: '12px',
    fontWeight: 600,
    color: theme.colorPalette.red_50
  },
  title: {
    color: theme.onCard.white,
    fontSize: 20,
    lineHeight: '24px',
    fontWeight: 600,
    ...reskinStyles(theme, { alignSelf: 'stretch', textAlign: 'left' })
  },
  subtitle: {
    textAlign: 'left',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    color: theme.onCard.beige_25
  },
  branchPlusEligible: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.colorPalette.green_80,
    color: theme.onCard.beige_25,
    borderRadius: theme.spacing(4),
    padding: theme.spacing(0, 2),
    height: 26,
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 600,
    ...reskinStyles(theme, theme.labelStyles.outlined)
  }
});

export default makeStyles(styles);
